export default __webpack_public_path__ + "static/media/Q15_2_resized.4d21a881.jpg";